var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("DC Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to DC Details List"
    },
    on: {
      "click": _vm.showCreateDeliveryDetailsData
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("DC Sit Code")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dcsitcode),
      expression: "dcsitcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "dcsitcode",
      "name": "dcsitcode",
      "maxlength": "30",
      "placeholder": "Enter DC Sit Code"
    },
    domProps: {
      "value": (_vm.dcsitcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dcsitcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dcsitcode')),
      expression: "errors.has('dcsitcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('dcsitcode')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Company Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyname),
      expression: "companyname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "companyname",
      "name": "companyname",
      "placeholder": "Enter Company Name",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.companyname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('companyname')),
      expression: "errors.has('companyname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('companyname')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Email")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "placeholder": "Enter Email",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Pincode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pincode),
      expression: "pincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "pincode",
      "name": "pincode",
      "placeholder": "Enter Pincode",
      "pattern": "^(\\d{6})$",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.pincode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "address",
      "name": "address",
      "maxlength": "255",
      "placeholder": "Enter Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("SPOC Person")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spocperson),
      expression: "spocperson"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "spocperson",
      "name": "spocperson",
      "placeholder": "Enter SPOC Name",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.spocperson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.spocperson = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('spocperson')),
      expression: "errors.has('spocperson')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('spocperson')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contact No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactno),
      expression: "contactno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:10'),
      expression: "'required|numeric|digits:10'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "contactno",
      "name": "contactno",
      "placeholder": "Enter Contact No",
      "maxlength": "10",
      "pattern": "^[6789](\\d)(?!\\1+$){3,}\\d{8}$"
    },
    domProps: {
      "value": (_vm.contactno)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactno')),
      expression: "errors.has('contactno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contactno')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("GST No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gstno),
      expression: "gstno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validate_gst'),
      expression: "'required|validate_gst'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "gstno",
      "name": "gstno",
      "placeholder": "Enter GST No"
    },
    domProps: {
      "value": (_vm.gstno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gstno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "gstBlock"
    }
  }, [_vm._v("Note: Allowed GST Format 00XXXXX0000X1ZZ.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('gstno')),
      expression: "errors.has('gstno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('gstno')))])], 1)]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])])]), _vm._v(" "), _c('br')], 1)])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4582aa34","hasScoped":true}!./src/modules/cargobooking/views/B2BMarketPlace/DeliveryDetails/CreateDeliveryDetails/CreateDeliveryDetails.component.html
// module id = 1307
// module chunks = 3